// putting it here avoids infinite dependency issues

import { isV3VH } from '@base/utility/VHHooks/useIsV3VH';

/** @type {(vhType: import("@core/models/virtualhuman.types").VHType) => boolean} */
export const GetServerCompletesSession = function (vhType) {
  return isV3VH(vhType);
};
